<app-header [pageTitle]="pageTitle" (back)="backToLeaveSyndicate()"></app-header>
<ion-content>
  <div class="upper-content-wrapper">
    <p class="tom-syndicate">{{ syndicate?.syndicate_name }}</p>
  </div>
  <div class="lower-content-wrapper">
    <p class="emoji">🏖️</p>
    <p class="reason-heading"> {{'take-holiday.week' | translate}}</p>
    <div class="reason-content">
      <p>{{'take-holiday.TakePaymentBreak' | translate}}</p>
      <p>{{'take-holiday.stillhave' | translate}}</p>

      <ul>
        <li>{{'take-holiday.usualdraws' | translate}}</li>
        <li>{{'take-holiday.access' | translate}}</li>
        <li>{{'take-holiday.rewardpoints' | translate}}</li>
      </ul>

      <p>{{'take-holiday.ourway' | translate}}
        <strong>{{'take-holiday.thankyou' | translate}}</strong>
        {{'take-holiday.ourway_desc_two' | translate}}
      </p>
    </div>
    <div>
      <ion-button class="proceed-btn" (click)="takePaymentHoliday(); startSpinner()">
        @if (!spinnerAnimation && proceed) {
          <span>{{'take-holiday.Take payment' | translate}}</span>
        }
        @if (spinnerAnimation) {
          <div class="spinners">
            <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
            </mat-progress-spinner>
          </div>
        }
        @if (!proceed) {
          <mat-icon [@bounceIn] class="tick-mark">{{'take-holiday.done' | translate}}</mat-icon>
        }
      </ion-button>
    </div>
    @if (tookHolidayError) {
      <div class="errorContainer">
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text">{{
          message ? message : "An error has ocurred. It was not possible to process your payment holiday at this time."
        }}</span>
      </div>
    }
  </div>
</ion-content>
<ion-row class="lower-most-content">
  <ion-col class="still-leave-wrap">
    <p class="still-leave" (click)="leave()">{{'take-holiday.leave' | translate}}</p>
  </ion-col>
</ion-row>